( function () {
    'use strict';
    e.news = {};
    e.news.init = function () {
        if ( jQuery( '.js-e-news-item' ).length > 1 ) {
            e.util.appendPageToBreadcrumb();
        }
        var jNewsPaging = jQuery( '.pagination' );
        if ( jNewsPaging.length === 1 ) {
            jQuery( '.page-list a' ).wrap( function () {
                var jListItem = jQuery( '<li></li>' );
                if ( jQuery( this ).find( 'b' ).length > 0 ) {
                    return jListItem.addClass( 'active' );
                }
                else {
                    return jListItem;
                }
            } );
            jNewsPaging.find( 'li' ).first().after( jQuery( '.page-list li' ) );
        }
    };
}() );
